import { moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Team } from '../shared/models';

@Component({
  selector: 'app-teams',
  templateUrl: './teams.component.html',
  styleUrls: ['./teams.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TeamsComponent {
  @Input()
  set teams(teams: Team[]) {
    this.dataSource = new MatTableDataSource(teams);
  }
  @Input() loading: boolean;
  @Output() replaceTeam: EventEmitter<any> = new EventEmitter();
  @Output() teamSelected: EventEmitter<any> = new EventEmitter();
  @Output() enableTeamsSave: EventEmitter<any> = new EventEmitter();

  @ViewChild('table') table: MatTable<any>;

  displayedColumns: string[] = [
    'dragHandler',
    'order',
    'name',
    'nusers',
    'ssoIds',
    'creator',
    'createDate',
    'modifier',
    'modifyDate',
    'action',
  ];
  dataSource: MatTableDataSource<any> = new MatTableDataSource([]);

  dropTable(event: any) {
    const prevIndex = this.dataSource.data.findIndex(d => d === event.item.data);
    moveItemInArray(this.dataSource.data, prevIndex, event.currentIndex);
    this.table?.renderRows();
    this.enableTeamsSave.emit();
  }
}
